// Function to add the 'title-anim' class when the element is in view
function activateAnimation(entries, observer, className) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add(className) // Add the animation class when visible
      observer.unobserve(entry.target) // Stop observing after animation starts
    }
  })
}

// Select the element(s) you want to observe
export const triggerAnimation = (animatedElements, className) => {
  // Options for the observer (optional: adjust threshold or rootMargin)

  // Create a new IntersectionObserver
  const observer = new IntersectionObserver(
    (e, b) => activateAnimation(e, b, className),
    {
      root: null, // null means the viewport
      threshold: 0.1, // Trigger when 50% of the element is visible
    }
  )
  // Observe each element
  animatedElements.forEach((element) => observer.observe(element))
}
